export default "__VITE_ASSET__D_jgiJCJ__"